export default "__VITE_ASSET__Bzbi7SKa__"